import { render, staticRenderFns } from "./GenerationHistoryDetailCardDesign.vue?vue&type=template&id=cd9d7c0a"
import script from "./GenerationHistoryDetailCardDesign.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryDetailCardDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports